export default "__VITE_ASSET__D7X6S5DM__"